<template>
  <VForm 
    ref="form"
    v-model="expense"
    :fields="childForm"
  />
</template>
<script>
  import VForm from '@/vuetify_custom/v-form'
  import receipt_five_select_mixins from '../mixins/receipt_five_select_mixins'
  const ruleValid = (text) => (val) => !!val || val === 0 || text
  export default {
    components: {
      VForm
    },
    mixins: [ receipt_five_select_mixins ],
    props: {
      value: {
        type: Object,
        default: () => ({})
      },
      bill_type: {
        type: String,
      }
    },
    data() {
      return {
        expense: this.value
      }
    },
    computed: {
      childForm() {
        return [
          this.name_field, // 子单名称
          this.team_field, // 费用承担团队
          {
            label: '收款金额',
            key:'total_amount',
            type:'number_field',
            d_digits:2,
            cols: 3,
            required: true,
            rules: [ ruleValid('收款金额'), (val) => {
              if (['sale_refund', 'other_refund'].includes(this.bill_type) && Number(val) >= 0) {
                return '退款单的金额须为负数'
              } 
              if (!['sale_refund', 'other_refund'].includes(this.bill_type) && Number(val) < 0) {
                return '收款单的金额须为正数'
              }
              return true
            } ],
          },
          this.account_title_field, // 会计科目
          this.analysis_title_field, // 分析科目
          this.invoice_type_field, // 发票信息
          this.remark_field // 备注信息
        ]
      },
    },
    watch: {
      expense(newVal) {
        this.$emit('input', newVal)
      },
      value(newVal) {
        this.expense = newVal
      }
    },
    methods: {
      getForm() {
        return this.$refs.form
      }
    }
  }
</script>